export enum SkyConfirmationDialogType {
  OKDialog = 1,
  YesCancelDialog = 2,
  YesNoCancelDialog = 3
}
